import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {AppAction} from '../../appActions';
import {
  ContactDetailsPanelAccountDetailsSubState,
  ContactDetailsSubStateTypesEnum,
} from '../contacts/contactDetailsPanelSubState';
import {AccountDetailsPanelActionsEnum} from './accountDetailsPanelActions';
import {AccountDetailsPanelState} from './accountDetailsPanelState';

export function accountDetailsPanelReducer(
  state: AccountDetailsPanelState,
  action: AppAction,
): AccountDetailsPanelState {
  return accountDetailsReducer(state, action) as AccountDetailsPanelState;
}

export function accountDetailsSubStateReducer(
  state: ContactDetailsPanelAccountDetailsSubState,
  action: AppAction,
): ContactDetailsPanelAccountDetailsSubState {
  return accountDetailsReducer(state, action) as ContactDetailsPanelAccountDetailsSubState;
}

export function accountDetailsReducer(
  state: AccountDetailsPanelState | ContactDetailsPanelAccountDetailsSubState,
  action: AppAction,
): AccountDetailsPanelState | ContactDetailsPanelAccountDetailsSubState {
  switch (action.type) {
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      if (stateIsContactDetailsSubState(state)) {
        return {
          ...state,
          status: AsyncStatusesEnum.LOADING,
          accountId: action.payload.accountId,
          isFetchRequired: false,
          conversationStatus: undefined,
          conversationIds: undefined,
          hasMoreConversations: undefined,
        };
      }
      return {
        ...state,
        status: AsyncStatusesEnum.LOADING,
        accountId: action.payload.accountId,
        conversationStatus: undefined,
        conversationIds: undefined,
        hasMoreConversations: undefined,
      };
    }
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_COMPLETED: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      if (stateIsContactDetailsSubState(state)) {
        return {
          ...state,
          status: AsyncStatusesEnum.LOADED,
          accountId: action.payload.accountId,
          isFetchRequired: false,
        };
      }
      return {
        ...state,
        status: AsyncStatusesEnum.LOADED,
        accountId: action.payload.accountId,
      };
    }
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_FAILED: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        status: AsyncStatusesEnum.FAILED,
      };
    }

    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_CARDS: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        cardsState: {
          loadingStatus: AsyncStatusesEnum.LOADING,
          cardIds: undefined,
        },
      };
    }
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_CARDS_COMPLETED: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        cardsState: {
          loadingStatus: AsyncStatusesEnum.LOADED,
          cardIds: action.payload.cardIds,
        },
      };
    }
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_CARDS_FAILED: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        cardsState: {
          loadingStatus: AsyncStatusesEnum.FAILED,
          cardIds: undefined,
        },
      };
    }

    // Conversations
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_CONVERSATIONS: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        conversationStatus: AsyncStatusesEnum.LOADING,
        conversationIds: undefined,
        hasMoreConversations: undefined,
      };
    }
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_CONVERSATIONS_COMPLETED: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        conversationStatus: AsyncStatusesEnum.LOADED,
        conversationIds: [...action.payload.conversationIds],
        hasMoreConversations: action.payload.hasMoreConversations,
      };
    }
    case AccountDetailsPanelActionsEnum.FETCH_ACCOUNT_CONVERSATIONS_FAILED: {
      if (!stateIsContactDetailsSubState(state) && state.id !== action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        conversationStatus: AsyncStatusesEnum.FAILED,
      };
    }

    case AccountDetailsPanelActionsEnum.CLEAR_FETCHED_DATA: {
      return {
        ...state,
        cardsState: undefined,
        conversationStatus: undefined,
        conversationIds: undefined,
        hasMoreConversations: undefined,
      };
    }

    default: {
      return state;
    }
  }
}

/*
 * Helpers.
 */

function stateIsContactDetailsSubState(
  subState: AccountDetailsPanelState | ContactDetailsPanelAccountDetailsSubState,
): subState is ContactDetailsPanelAccountDetailsSubState {
  return subState.type === ContactDetailsSubStateTypesEnum.ACCOUNT_DETAILS;
}
